import { render, staticRenderFns } from "./LeadCustomFields.vue?vue&type=template&id=49626a78&scoped=true&"
import script from "./LeadCustomFields.vue?vue&type=script&lang=js&"
export * from "./LeadCustomFields.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49626a78",
  null
  
)

export default component.exports